<template>
    <div class="courseChoose"
        :style="{ 'width': _isMobile() ? '100%' : '1200px', 'margin': _isMobile() ? '-28px auto' : 'auto' }">
        <div class="mainContent" :style="{ borderRadius: _isMobile() ? '28px 28px 0 0' : 'none' }"
            v-if="dataSource.length > 0">
            <!-- <template v-if="_isMobile()"> -->
            <div class="header">
                <template v-if="_isMobile()">
                    <i class="iconfont">&#xe664;</i>课程选择
                </template>
            </div>
            <template v-if="pageType == 'ZXKS' || pageType == 'ZXLX' || pageType == 'BJZY'  ">
                <a-row type="flex" justify="space-between" style="width: 90%;margin: 0 auto;">
                    <a-col :xs="24" :sm="24" :md="18" :lg="18" :xl="12">
                        <div class="menuList" @click="openHandelFn(dataSourceOne)">
                            <img src="../../assets/image/KC_JSJ.png" style="width: 100%;" alt="">
                            <div class="menuName" style="font-size: 62px;">{{  dataSourceOne.title }} <i class="iconfont"
                                    style="font-size: 36px;">&#xe626;</i></div>
                        </div>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-between" :gutter="[0, 42]" style="width: 90%;margin: 0 auto;">
                    <a-col :xs="11" :sm="11" :md="7" :lg="7" :xl="5" v-for="item, index in dataSource" :key="index">
                        <div class="menuList" @click="openHandelFn(item)">
                            <img  :src="require('../../assets/image/KC_' + item.value +'.png')" style="width: 100%;" alt="">
                            <div class="menuName">{{  item.title }} <i class="iconfont"
                                    style="font-size: 20px;">&#xe626;</i></div>
                        </div>
                    </a-col>
                </a-row>
            </template>
            <template v-else>
                <a-row type="flex" justify="space-between" style="width: 90%;margin: 0 auto;">
                    <a-col :xs="24" :sm="24" :md="18" :lg="18" :xl="12">
                        <div class="menuList" @click="openHandelFn(dataSourceOne)">
                            <img :src="dataSourceOne.courseCover_url" style="width: 100%;" alt="">
                            <div class="menuName" style="font-size: 62px;">{{ dataSourceOne.courseName }} <i class="iconfont"
                                    style="font-size: 36px;">&#xe626;</i></div>
                        </div>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-between" :gutter="[0, 42]" style="width: 90%;margin: 0 auto;">
                    <a-col :xs="11" :sm="11" :md="7" :lg="7" :xl="5" v-for="item, index in dataSource" :key="index">
                        <div class="menuList" @click="openHandelFn(item)">
                            <img :src="item.courseCover_url" style="width: 100%;" alt="">
                            <div class="menuName">{{ item.courseName  }} <i class="iconfont"
                                    style="font-size: 20px;">&#xe626;</i></div>
                        </div>
                    </a-col>
                </a-row>
            </template>
            
        </div>
    </div>
</template>
<script>
import { mixinDevice } from "@/utils/mixin.js";
import { getAction } from '@/api/manage'
export default {
    name: 'courseChoose',
    components: {},
    mixins: [mixinDevice],
    data() {
        return {
            dataSourceOne: {},
            dataSource: [],
            pageType: ''
        }
    },
    created() {
        this.pageType = this.$route.query.type
        this.init(this.$route.query.type)
    },
    mounted() { document.title= this.$route.query.name },
    methods: {
        init(type) {
            this.loading = true
            if (type == 'ZXKS' || type == 'ZXLX' || type == 'BJZY') {
                getAction('/sys/dict/getDictItems/paper_type').then(res=>{
                    console.log(res , '')
                    if(res.success){
                        let index = res.result.findIndex(v=> v.value == 'XLJK')
                        res.result.splice(index,1)
                        this.dataSourceOne = res.result[0]
                        this.dataSource = res.result.slice(1, res.result.length)
                    }
                })
            } else {
                getAction('/teaching/teachingCourse/studentCourseNew', { courseType: 8, pageSize: 999 }).then(res => {
                    if (res.success) {
                        this.dataSourceOne = res.result[0]
                        this.dataSource = res.result.slice(1, res.result.length)
                    }
                    if (res.code === 510) {
                        this.$message.warning(res.message)
                    }
                    this.loading = false
                })
            }

        },
        openHandelFn(row) {
            console.log(row)
            if (this.pageType == 'ZXKS' || this.pageType == 'ZXLX' || this.pageType == 'BJZY') {
                this.$router.push({ path: 'examEntrance', query: { paperType:row.value ,type:this.pageType} });
            } else if (this.pageType == 'ZXXX') {
                this.$router.push({ path: '/examination/chapter', query: { name: row.courseName, id: row.id } });
            } else {
                this.$router.push({ path: 'operate', query: { name: row.courseName, id: row.id } });
            }
        }
    }
}
</script>
<style lang='scss' scoped>
.courseChoose {
    width: 100%;
    margin: -28px auto;

    .mainContent {
        width: 100%;
        background: #fff;

        .header {
            width: 100%;
            height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 17px;
            color: #333;
            position: relative;

            .jxwLogo {
                width: 67px;
                height: 70px;
                position: absolute;
                top: -31px;
                right: 13px;
                z-index: 9;
            }
        }
    }

    .menuList {
        width: 100%;
        height: auto;
        background-size: 100% 100%;
        border-radius: 14px;
        box-shadow: 0px 0px 12px 0px rgba(25, 32, 68, 0.35);
        overflow: hidden;
        position: relative;
        cursor: pointer;
        .menuName {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: #33333338;
            font-size: 42px;
            color: #fff;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;

            .iconfont {
                padding-left: 8px;
            }
        }
    }
}
</style>
  